// Spokane Orthodontics (Spokane WA) - single office. Rebranded from "Bret Johnson
// Orthodontics" 2026-08-27, when Bond flipped the WPEngine primary domain from
// drbretortho.com to spokaneorthodontics.com (the old domain 301s to the new one).
// `slug`/`brandId` stay "johnson": they key bondLocations.ts JOHNSON_SPOKANE, the
// hosting target + canonical (johnson-booking.web.app), the embed's ?brand=, and
// the analytics/GBP records. Renaming them would break live bookings, so the
// rename is display-only.
// Backend: bondLocations.ts JOHNSON_SPOKANE (brandId "johnson", catalog 6ae05d26,
// Edge loc 4, procedure 30, DB 359). Native booking via ortho2-newpatient backend
// (WCF intake disabled - login not provisioned on DB 359). English-only.
import type { BrandConfig } from "./types";

export const johnson: BrandConfig = {
  slug: "johnson",
  brandId: "johnson",
  brandName: "Spokane Orthodontics",
  // Self-hosted, unlike every other brand: at rebrand time the new site still
  // served the retired Bret Johnson mark at its /wp-content logo path, so
  // pointing at the practice site would have kept the old logo in the widget.
  // Served from the widget's own origin; swap to the practice URL once Boom
  // publishes the new mark.
  logo: "/logos/spokane-orthodontics.png",
  phone: "(509) 466-2666",
  phoneHref: "tel:+15094662666",
  theme: { primary: "#66C4AB", primaryDark: "#344C60" }, // sampled 2026-08-27 from the new logo (mint accent + slate wordmark)
  locales: ["en"],
  locations: {
    JOHNSON_SPOKANE: {
      id: "JOHNSON_SPOKANE",
      name: "Spokane",
      addressLines: ["10306 N. Nevada St.", "Spokane, WA 99218"],
      mapsUrl: "https://maps.google.com/?q=10306+N+Nevada+St+Spokane+WA+99218",
      timezone: "America/Los_Angeles",
    },
  },
  locationAliases: { SPOKANE: "JOHNSON_SPOKANE", JOHNSON: "JOHNSON_SPOKANE" },
};
